enum Motivation {
  CONFIDENCE = 'Confidence',
  HEALTH = 'Health',
  FEEL_BETTER = 'Feel Better',
  PROVE_CAPABLE = 'Prove Capable',
}

const motivationQuestion = {
  name: 'motivation',
  type: 'radiogroup',
  // showOtherItem: true,
  isRequired: true,
  colCount: 1,
  title: 'What is your main reason for getting in shape?',
  description: "We’re always learning what keeps people going, and your answer helps.",
  choices: [
    { value: Motivation.CONFIDENCE, text: "Feel more confident" },
    { value: Motivation.HEALTH, text: "Become healthier" },
    { value: Motivation.FEEL_BETTER, text: "Feel better in my body" },
    { value: Motivation.PROVE_CAPABLE, text: "Show myself I’m capable" },
  ],
};

export {
  motivationQuestion,
  Motivation,
}